<template>
  <!-- 服务商管理 -->
  <div>
    <app-page>
      <template #fheader>
        <div class="fan-search margin-bottom-8">
          <jr-search2
            ref="searchForm"
            :form-list="formList"
            :search-value.sync="queryForm"
            :loading="loading"
            @search="handleSearch"
            @reset="handleReset"
            trackCode='servicerList-1'
          />
        </div>
      </template>
      <template #header>
        <div class="fan-search">
          <page-select-groups :search-value.sync="queryForm" @change="refreshList" :selectList="selectList" />
          <div class="fan-search-col fan-search-right" v-if="$has('FWS-FWSGL-DC')">
            <page-export-button
              buttonText="导出"
              exportServe="fin_account_customerReport"
              :total="total"
              :isLimit="true"
              :exportParams="exportParams"
              trackCode='servicerList-3'
            />
          </div>
        </div>
        <div class="radio-group" v-if="serviceTypeList && serviceTypeList.length>1">
          <el-radio-group v-model="queryForm.serviceType" @change="handleChangeType">
            <el-radio-button v-for="item in serviceTypeList" :key="item.value" :label="item.value">{{ item.label }}</el-radio-button>
          </el-radio-group>
        </div>
      </template>
      <template #main="{ height }">
        <jr-table
          :height="height"
          :key="height"
          :loading="loading"
          :tableData="list"
          :tableColumn="tableColumn"
        />
      </template>
      <template #ffooter>
        <pagination
          :total="total"
          :current-page="queryForm.page"
          :size="queryForm.limit"
          :pageSizes="[10]"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </template>
    </app-page>
    <!-- 详情 -->
    <detail
      ref="customerDetail"
      :visible.sync="isDetailShow"
      :current-item.sync="currentItem"
    />
  </div>
</template>

<script>
import { getCustomerList } from '@/api/servicer';
import { setStatusColor } from '@/filters/index';
import detail from './components/detail';

const queryFormDefault = {
  beginTime: '', // 开始时间
  endTime: '', // 结束时间
  page: 1,
  limit: 10,
  searchContent: '', // 搜索值
  searchType: '1',
  status: '', // 客户状态： 1 待实名 2 正常 3 已锁定 4 已停用 -1 已销户
  principalType: 1, // 主体类型：0 普通商户 1服务商
  timeType: '1',
  serviceType: '', // 服务商类型: 1-百布服务商,2-一批商
};

export default {
  name: 'ServicerList',
  components: { detail },
  data() {
    return {
      loading: false,
      queryForm: JSON.parse(JSON.stringify(queryFormDefault)),
      list: [],
      total: 0,
      formList: [
        {
          prop: 'timeType',
          component: 'select-date-picker',
          options: [
            { label: '注册时间', value: '1' },
          ],
        },
        {
          prop: 'searchType',
          contentProp: 'searchContent',
          component: 'search-input-select',
          attrs: {
            type: 'text',
            placeholder: '请输入内容',
          },
          options: [
            { value: '1', label: '服务商名称' },
            { value: '3', label: '服务商客户编号' },
            { value: '2', label: '服务商财务编号' },
            { value: '4', label: '服务商账户编号' },
          ],
        },
      ],
      isDetailShow: false, // 详情弹窗
      currentItem: {},
      tableColumn: [
        { prop: 'customerNo', label: '服务商财务编号', minWidth: '1', click: (row) => this.handleDetail(row), show: () => this.$has('FWS-FWSGL-XQ'), trackCode: 'servicerList-2' },
        { prop: 'businessNo', label: '服务商客户编号', minWidth: '1' },
        { prop: 'thirdAccountNo', label: '服务商账户编号', minWidth: '1' },
        { prop: 'businessName', label: '服务商名称', minWidth: '1' },
        // { prop: 'principalTypeDesc', label: '主体类型', minWidth: '1' },
        { prop: 'accountAmount', label: '资金账户余额(元)', filterName: 'toFenThousandsAndFloat' },
        { prop: 'feeAccountAmount', label: '手续费账户余额(元)', filterName: 'toFenThousandsAndFloat' },
        { prop: 'registerTime', label: '注册时间', minWidth: '1', filterName: 'formatTime' },
        { label: '服务商状态', status: 'status', statusDesc: 'statusDesc', statusColor: (val) => setStatusColor(val, 'servicerStatus') },
      ],
      selectList: [
        {
          title: '服务商状态',
          prop: 'status',
          dictionaryPath: '/finance/finance-account/FinCustStatusEnum',
        },
      ],
      serviceTypeList: [], // 服务商类型集合
    };
  },
  computed: {
    exportParams() {
      const params = { ...this.queryForm };
      delete params.page;
      delete params.limit;
      return params;
    },
  },
  created() {
    const list = [];
    this.queryForm.serviceType = '';
    if (this.$has('FWS-FWSGL-BBFWS')) {
      list.push({ value: '1', label: '百布服务商' });
      this.queryForm.serviceType = '1';
    }
    if (this.$has('FWS-FWSGL-YPFWS')) {
      list.push({ value: '2', label: '一批商' });
      this.queryForm.serviceType = this.queryForm.serviceType || '2';
    }
    this.serviceTypeList = list;
    this.getList();
  },
  methods: {
    // 切换服务商类型
    handleChangeType() {
      this.queryForm.page = 1;
      this.getList();
    },
    // 列表查询
    handleSearch(params = {}) {
      this.queryForm = { ...this.queryForm, ...params, page: 1 };
      this.getList();
    },
    // 重置搜索条件
    handleReset() {
      this.queryForm = JSON.parse(JSON.stringify(queryFormDefault));
      this.getList();
    },
    refreshList() {
      this.queryForm.page = 1;
      this.getList();
    },
    // 分页操作
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(limit) {
      this.queryForm.page = 1;
      this.queryForm.limit = limit;
      this.getList();
    },
    // 列表接口请求
    async getList() {
      try {
        const param = { ...this.queryForm };
        this.loading = true;
        this.list = [];
        delete param.timeType;
        const res = await getCustomerList(param);
        this.total = res.totalCount || 0;
        this.list = res.data || [];
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.list = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    // 查看详情
    handleDetail(row) {
      this.currentItem = { ...row };
      this.isDetailShow = true;
    },
  },
};
</script>
